/**
 * please use `const { spacing } = useTheme()` in your component when you
 * need to set multiple things, example spacing(1, 2)
 * This is an internal function, which gets transformed in our create theme
 * and only directly used in create theme components
 *
 * @example external `const { spacing } = useTheme(); ... spacing(1, 2)`
 * @example internal `spacing(1, 2)`
 */
export const spacing = (...factors: number[]) =>
  (factors.length ? factors : [1]).reduce((result, factor) => `${result} ${0.5 * factor}rem`, '').trimStart()
